export default "__VITE_PUBLIC_ASSET__dc44a421__"